const PencilLine = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.75 15.1879H3.375C3.22582 15.1879 3.08274 15.1286 2.97725 15.0232C2.87176 14.9177 2.8125 14.7746 2.8125 14.6254V11.4834C2.8125 11.4095 2.82705 11.3364 2.85532 11.2681C2.88359 11.1999 2.92502 11.1379 2.97725 11.0857L11.4148 2.64815C11.5202 2.54266 11.6633 2.4834 11.8125 2.4834C11.9617 2.4834 12.1048 2.54266 12.2102 2.64815L15.3523 5.79016C15.4577 5.89565 15.517 6.03872 15.517 6.1879C15.517 6.33709 15.4577 6.48016 15.3523 6.58565L6.75 15.1879ZM6.75 15.1879H15.1875M6.75 15.1879L2.84829 11.2862M9.5625 4.5004L13.5 8.4379"
        stroke={'currentColor'}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default PencilLine;
